function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "M58.113 40.63c-1.384 3.898-3.773 7.42-7.044 10.691C45.284 57.107 38.24 60 29.937 60c-8.301 0-15.345-2.893-21.258-8.679-3.019-3.02-5.408-6.541-6.792-10.315C.629 37.61 0 33.962 0 30.063c0-8.177 2.892-15.346 8.678-21.258C14.592 2.894 21.636 0 29.937 0c8.302 0 15.346 2.894 21.258 8.805 5.912 5.912 8.806 12.956 8.806 21.258 0 3.773-.63 7.295-1.888 10.566",
  fill: "#19ACE3"
});

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  d: "M20.762 11.65C23.254 9.216 26.28 8 29.84 8c3.56 0 6.598 1.216 9.114 3.65 2.493 2.456 3.738 5.399 3.738 8.829 0 3.475-1.245 6.442-3.738 8.898-2.516 2.433-5.554 3.65-9.114 3.65-3.56 0-6.586-1.217-9.078-3.65-2.516-2.457-3.774-5.423-3.774-8.898 0-3.43 1.257-6.373 3.774-8.83M2 41.44c3.323-3.036 7.263-4.554 11.82-4.554h32.966c4.343 0 8.081 1.425 11.214 4.275-1.449 3.777-3.763 7.218-6.942 10.324C45.219 57.16 38.182 60 29.946 60c-8.259 0-15.32-2.839-21.182-8.516C5.679 48.472 3.424 45.123 2 41.438",
  fill: "#7ED2EF"
});

var SvgIconCircleDoctor = function SvgIconCircleDoctor(_ref) {
  var title = _ref.title,
      props = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 60 60"
  }, props), React.createElement("title", null, title), _ref2, _ref3);
};

export default SvgIconCircleDoctor;